import React, {useState} from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './market.css';
import 'boxicons';
import Modal from 'react-modal';
import { isMobile } from 'react-device-detect';
Modal.setAppElement('#root');

const Bama=()=>{
    const [wow, setwow] = useState({});
    const [pwck, setpwck] = useState();
    const [idname, setidname] = useState();
    const [idc, setidc] = useState(false);
    const [pc, setpc] = useState(false);
    const [spin, setspin] = useState(false);
    const [prg, setprg] = useState();
    const [ming, setming] = useState();
    const [kii, setkii] = useState();
    const [yond, setyond] = useState();
    const [brand, setbrand] = useState();
    const [biznum, setbiznum] = useState();
    const [nums, setnums] = useState();
    const [mailch, setmailch] = useState(false);
    const [uka, setuka] = useState();
    const customStyles = {
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
        },
      };
    const noback = useNavigate();
    const jama = async (co)=>{
        co.preventDefault();
        const setn = co.target.id.value;
       
        if(idname !== setn){
            document.getElementById('ida').textContent="중복 확인 필요";
            return;
        };
        if(!idc){
            document.getElementById('ida').textContent="중복 확인 필요";
            return;
        };
        if(!pc){
            document.getElementById('toka').textContent="번호 확인 필요";
            return;
        };
        if(!mailch){
            document.getElementById('jni').textContent="메일 확인 필요";
            return;
        };
        const aruki = document.querySelector('input[name="mail"]').value;
    
        if(aruki !== uka){
            document.getElementById('sosok').textContent = "메일 변경 확인 필요";
            return;
        };
    //기업회원 정보 저장 데이터 베이스 설정   
        setspin(true);
        const jana = await axios.post('/api/biz',{id : co.target.id.value, pw : co.target.pw.value, mail : co.target.mail.value,
             name : co.target.mingzi.value, brand : co.target.brand.value, biznum : co.target.biznum.value, tels : co.target.tels.value},
        {onUploadProgress : data=>{if(data.total){setprg(Math.round((100*data.loaded)/data.total))}}})
        .then(res=>{setwow(res.data); setspin(false);}).catch(e=>{
                const missy = e.response?.data?.condition;
                if(missy === "rollover"){
                    const lawsc = e.response?.data?.missing;
                    if(lawsc === "id"){document.getElementById('ida').textContent="ID를 입력해주세요";} else if(lawsc === "name"){
                        document.getElementById('poku').textContent = "이름을 입력해주세요";
                    } else if(lawsc === "pw"){ document.getElementById('toku').textContent = "번호를 입력해주세요";} else if(lawsc ==="mail"){
                        document.getElementById('sosok').textContent = "메일을 입력해주세요";
                    } else if(lawsc === "brand"){document.getElementById('brnd').textContent = "기업명을 입력해주세요";}else if(lawsc === "biznum"){
                        document.getElementById('bizn').textContent = "번호를 입력해주세요";
                    };
                }else if(missy === "notpassword"){
                    document.getElementById('toku').textContent = "비밀번호는 영문, 숫자 조합의 6자리 이상 10자리 이하입니다";
                }else if(missy === "redundancy"){
                    document.getElementById('ida').textContent = "이미 사용 중이네요";
                }else if(missy ==="nojoin"){ document.querySelector('#jni').textContent = "🚨일시적 오류가 발생했어요"; } else{
                    document.querySelector('#jni').textContent = "🚨일시적 오류가 발생했어요";
                };
                setspin(false);});
    };

    document.title = "기업회원 가입 - 돌파공모";

    const noth = async ()=>{
        //const kake = await axios.get('api/gone').then(dadi=>dadi.data).catch(e=>console.log("zaza"));
        window.open("http://localhost:3001/api/auth/google", "_self"); 
    };

    const jwjw = async ()=>{
        const kake = await axios.post('api/very').then(dadi=>dadi.data).catch(e=>console.log("JWT-auth"));
    };

    if(wow?.id){
        setTimeout(() => {
            noback('/join', {replace : true});}, 2000);
    };

    const re = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{6,10}$/;
    const pwcheck=(e)=>{
        const ok = re.test(e.target.value);
       
        if(!ok){
            document.getElementById('toku').innerText="영문,숫자,특수문자 포함 6자리 이상 10자리 이하입니다";
            setpwck();
        }else{
            setpwck(e.target.value);
            document.getElementById('toku').innerText="ok";
        };
    };
    const namecheck=(e)=>{
        const fok = e.target.value;
       
        if(!fok){
            document.getElementById('poku').innerText="담당자 확인을 위해 필요합니다";
            setming();
        }else{
            setming(e.target.value);
            document.getElementById('poku').innerText="ok";
        };
    };
    const brandcheck=(e)=>{
        const fok = e.target.value;
       
        if(!fok){
            document.getElementById('brnd').innerText="공고 등록을 위해 필요합니다";
            setbrand();
        }else{
            setbrand(e.target.value);
            document.getElementById('brnd').innerText="ok";
        };
        setyond('');
    };
    const biznumcheck=(e)=>{
        const fok = e.target.value;
        
        if(!fok){
            document.getElementById('bizn').innerText="공고 등록을 위해 필요합니다";
            setbiznum();
        }else{
            setbiznum(e.target.value);
            document.getElementById('bizn').innerText="ok";
        };
        setyond('');
    };
    const numscheck=(e)=>{
        const fok = e.target.value;
      
        if(!fok){
            document.getElementById('nums').innerText="공고 등록을 위해 필요합니다";
            setnums();
        }else{
            setnums(e.target.value);
            document.getElementById('nums').innerText="ok";
        };
        setyond('');
    };

    const pwchecka=(e)=>{
        const fok = e.target.value;
       
        if(fok == pwck){
            document.getElementById('toka').innerText="ok";
            setpc(true);
        }else if(!fok){
            document.getElementById('toka').innerText="번호를 입력해주세요";
            setpc(false);
        }else{
            document.getElementById('toka').innerText="번호가 일치하지 않아요";
            setpc(false);
        }
    };
    const ke = /^[가-힣a-zA-Z0-9]{2,10}$/;
    const idcheck= async (e)=>{
        const iddd = e.target.value;
        const okk = ke.test(iddd);
        if(!okk){
            document.getElementById('ida').innerText="한글, 영문, 숫자로 2개 이상 10개 이하 문자로 구성!";
            setidc(false);
        }else{
            // const retua = await axios.get(`/api/bidcheck/${iddd}`).then(aa=>{return aa.data;}).catch(err=>console.log("err in idcheck"));
            // if(retua){
            //     document.getElementById('ida').innerText="ok!";
            //     setidc(true);
            //     setidname(iddd);
            // }else{
            //     document.getElementById('ida').innerText="이미 사용 중이네요";
            //     setidc(false);
            // }; 

            try {
                const response = await axios.get(`/api/bidcheck/${iddd}`);
                const isAvailable = response.data;
              
                if (isAvailable) {
                  document.getElementById('ida').textContent = "ok";
                  setidc(true);
                  setidname(iddd);
                } else {
                  document.getElementById('ida').textContent = "이미 사용 중이네요";
                  setidc(false);
                }
              } catch (err) {
                console.error("err in idcheck", err);
                document.getElementById('ida').textContent = "오류가 발생했습니다";
                setidc(false);
              };
        };
    };

    let submitop = false;
    const authy= async ()=>{
        const dmal = document.querySelector('input[name="mail"]').value;
        const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const hang = re.test(dmal);
        if(submitop){return;};
        if(kii){return;};
        if(!hang){
            alert("이메일 형식이 맞지 않습니다");
            return;
        };
        submitop = true;
        const sbut = document.querySelector('#canbi');
        sbut.classList.add('dith');
     
        try{
            const dims = await axios.post('/api/gotmail', {mail : dmal});
            setkii(dims.data.condition);
        }catch(err){
            if(err.response.data.condition == "mailaddress"){
                document.getElementById('sosok').textContent = "메일주소 확인이 필요해요";
            };
        }finally{
            submitop = false;
            sbut.classList.remove('dith');
        };
    };

    const matchy= async ()=>{
        const kiib = document.querySelector('input[name="firm"]').value;
        const dmal = document.querySelector('input[name="mail"]').value;
        if(kii !== "prove"){
            document.querySelector('#jni').textContent = "🚨인증 과정이 필요해요"; 
            document.querySelector('#jni').style.fontWeight = "500";
            document.querySelector('#jni').style.fontSize = "14px";
            document.querySelector('#jni').style.color = "#ff3131de";
            return;
        };
        try{
            const dims = await axios.post('/api/verifyc', {mail : dmal, code : kiib});
            if(dims.data.condition === "passup"){
                document.querySelector('#jni').textContent = "✅완료!";
                document.querySelector('#jni').style.fontWeight = "500";
                document.querySelector('#jni').style.fontSize = "14px";
                setmailch(true);
                setuka(dmal);
            }
        }catch(err){
            const beens = document.querySelector('#jni');
            const condition = err.response?.data?.condition;
            if(condition === "overtime"){
                beens.textContent = "🚨인증 시간 만료 또는 요청 이력이 없어요";
            } else if (condition === "notsame"){
                beens.textContent = "🚨일치하지 않아요";
            } else if (condition === "serviceout"){
                beens.textContent = "🚨메일로 문의해주세요";
            } else if (condition === "notverify"){
                beens.textContent = "🚨이메일과 인증번호 모두 입력해주세요"
            } else{
                beens.textContent = "🚨일시적인 오류가 발생했습니다"
            };
            beens.style.fontWeight = "500";
            beens.style.fontSize = "14px";
            beens.style.color = "#ff3131de";
            setmailch(false);
        };
    };

    const vvos=(e)=>{
       
        setyond(e.target.name);
    };
    const bbos=(e)=>{
        setyond('');
    };

    
    return(
    <>
    <Modal isOpen={spin} style={customStyles}><progress className="pure-material-progress-circular"/></Modal>
    
    {wow?.id ? <><h2>가입을 축하합니다!! 공모전,대외활동,교육 참여와 홍보에 힘을 보탤게요^^</h2></> :
        <>
        <h2>회원가입{prg}</h2>
        <form className={isMobile ? 'mfamm' : 'famm'} onSubmit={jama}>
        <div className={isMobile ? 'mhoiwon' : 'hoiwon'}>
           
            <h3><label for="id">아이디</label></h3>
            <span className='j1'>
                <input type='text' name='id' required onBlur={idcheck}/>
            </span>
            <span id="ida"></span>
                    
            <h3><label for="mingzi">담당자(이름)</label></h3>
            <span className='j1'>
                <input type='text' name='mingzi' required onBlur={namecheck}/>
            </span>
            <span id="poku"></span>

            <h3><label for="pw">비밀번호</label></h3>   
            <span className='j1'>
                <input type='password' name='pw' required  onBlur={pwcheck}/>
            </span>
            <span id='toku'></span>
                    
            <h3><label for="pwcc">비밀번호 재확인</label></h3>   
            <span className='j1'>
                <input type='password' name='pwcc' required  onBlur={pwchecka}/>
            </span>
            <span id='toka'></span>

            <h3><label for="brand">기업명</label></h3>
            <span className={yond == 'brand' ? 'j1 j2' : 'j1'}>
                <input type='text' name='brand' required onBlur={brandcheck} onFocus={vvos} />
            </span>
            <span id="brnd"></span>

            <h3><label for="biznum">사업자등록번호</label></h3>
            <span className={yond == 'biznum' ? 'j1 j2' : 'j1'}>
                <input type='text' name='biznum' pattern="[0-9-]+" required onBlur={biznumcheck} onFocus={vvos}/>
            </span>
            <span id="bizn"></span>

            <h3><label for="tel">연락처</label></h3>
            <span className={yond == 'tels' ? 'j1 j2' : 'j1'}>
                <input type='text' name='tels' id='tel' onFocus={vvos} onBlur={numscheck} required/>
            </span>
                    
            <h3><label for="mail">이메일</label></h3>  
            <span className='j1'>
                <input type='email' name='mail' required/>
            </span>
            <span id='sosok'></span>
            <span className='jiyip' id='canbi' onClick={authy} style={{cursor:"pointer"}}>
                인증메일 발송{kii && <span style={{marginLeft:"6px"}}>완료</span>}
            </span>
            <h3><label htmlFor="numfirm" className='firmnum'>번호입력</label><span id='jni' className='jiyr'></span></h3>
            <div style={{width:"100%", margin:"0 auto"}}>
            <span className='jeonson'>
                <input type='text' name='firm' id='numfirm' className='jeoninput'/>
            </span>
            <span className='jiyip3'>
                <span onClick={matchy} className='jiyip2'>확인</span>
              
            </span>
            </div>
            <button className='gayip' onSubmit={jama}>가입하기</button>
        </div>
        </form>
        </> 
    }
   </>
    );
    }
    
    export default Bama;